import { render, staticRenderFns } from "./receivingAdress.vue?vue&type=template&id=7127ae2e&scoped=true&"
import script from "./receivingAdress.vue?vue&type=script&lang=js&"
export * from "./receivingAdress.vue?vue&type=script&lang=js&"
import style0 from "./receivingAdress.vue?vue&type=style&index=0&id=7127ae2e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7127ae2e",
  null
  
)

export default component.exports